// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".qrcodeimg[data-v-41af8606]{width:40%;position:relative;left:50%;transform:translateX(-50%)}.p[data-v-41af8606],h2[data-v-41af8606]{text-align:center}", ""]);
// Exports
module.exports = exports;
